import { useState, useEffect } from 'react';
import Stack from '@mui/joy/Stack';
import Typography from '@mui/joy/Typography';
import Input from '@mui/joy/Input';

import Button from '@mui/joy/Button';

import Success from 'components/Success';

import { FHRequestType } from 'stores/fhrequest_store';
import useFHRequest from 'hooks/useFHRequest';
import useRoles from 'hooks/useRoles';
import useWorkKey from 'hooks/useWorkKey';

const RequestInfoEditCredits = ({ request, setEditing }: { request: FHRequestType, setEditing: (s: string) => void }) => {

    const workKey = useWorkKey();
    const { hasRole } = useRoles();
    const { supportUpdatePrice } = useFHRequest();
    const [credits, setCredits] = useState(request.task_credits);
    const [price, setPrice] = useState(`${request.price}`);
    const PRICE_INCREMENT =  3.00;

    useEffect(() => {
        setPrice((PRICE_INCREMENT * credits).toFixed(2));
    }, [credits]);

    function onChangeCredits(e: number) {
        console.log("setting credits to: ", e);
        setCredits(e);
    }

    async function doSave() {
        if(!workKey) {
            return;
        }
        await supportUpdatePrice(workKey, request.uuid, credits, price);
        setEditing('');
        Success('Price updated');
    }

    if(!workKey || !request) {
        return null;
    }
    if(!hasRole('support')) {
        return null;
    }

    return (
        <Stack
            my={2}
            spacing={2}
            alignItems="center"
        >
            <Typography
                color="success"
                level="title-sm">
                Edit Credits
            </Typography>

            <Input type="number"
                defaultValue={request.task_credits}
                onChange={(e) => { onChangeCredits(parseInt(e.target.value)); }}

            />

            <Input type="text"
                onChange={(e) => { setPrice(e.target.value); }}
                value={price}
                defaultValue={price}
            />

            <Stack spacing={1} direction="row" alignItems="space-between">
                <Button
                    size="sm"
                    variant="plain"
                    onClick={() => { setEditing(''); }}>Cancel</Button>
                <Button
                    size="sm"
                onClick={doSave}
            >Save</Button>
            </Stack>
        </Stack>
    );

}

export default RequestInfoEditCredits;
